'use client';

import { useEffect, useState } from 'react';
import styles from './CookieConsent.module.css';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => setVisible(true);
    document.addEventListener('open-cookie-settings', handler);
    return () => document.removeEventListener('open-cookie-settings', handler);
  }, []);

  const acceptCookies = () => {
    const essential = { essential: true };
    localStorage.setItem('cookie-consent', JSON.stringify(essential));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <p className={styles.text}>
        We use only essential cookies required for the site to function. 
        Read our <a href="/cookies" className={styles.link}>Cookie Policy</a>.
      </p>
      <button onClick={acceptCookies} className={styles.button}>
        OK
      </button>
    </div>
  );
}
